import React from 'react';
import classNames from 'classnames';
import { Dayjs } from 'dayjs';
import { isWeekday } from '../../lib/isWeekday';

import styles from './WeekDayHeader.module.scss';

const WeekDayHeader = ({ day }: { day: Dayjs }): React.ReactElement => (
  <div
    className={classNames(styles.weekDaysItem, {
      [styles.weekendDayItem]: isWeekday(day),
    })}
  >
    {day.localeData().weekdaysMin()[day.day()]}
  </div>
);

export default React.memo(WeekDayHeader);
